/**
 * OKS-519 — "member since" formatter.
 *
 * Renders an ISO8601 instant as a locale-aware short "{Mon YYYY}" label
 * (e.g. `"Jan 2026"` / `"janv. 2026"`) for the §13 leaderboard rows.
 * Pure; `Intl.DateTimeFormat` is a browser builtin (polyfilled in jsdom).
 *
 * @param iso    ISO8601 timestamp (the membership `joined_at`).
 * @param locale BCP-47 tag; defaults to `"fr"` (Crew default).
 * @returns the formatted month-year, or `""` when `iso` is unparseable.
 */
export function formatMonthYear(iso: string, locale?: string): string {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ""

  return new Intl.DateTimeFormat(locale ?? "fr", {
    month: "short",
    year: "numeric",
  }).format(date)
}
